import {
  FETCH_ONDUTY_SUCCESS,
  CREATE_ONDUTY,
  UPDATE_ONDUTY,
  DELETE_ONDUTY,
  SET_ONDUTY_ID
} from "actions/types";

import {
  onDutyRead,
  onDutyCreate,
  onDutyUpdate,
  onDutyDelete,
} from "../api";
import {
  dataFailure,
  dataSuccess,
} from "./general";


const fetchOnDutySuccess = (values) => {
  return {
    type: FETCH_ONDUTY_SUCCESS,
    payload: values,
  };
};

export const fetchOnDuty = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyRead(values));
      await dispatch(fetchOnDutySuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const createOnDutyData = (values) => {
  return {
    type: CREATE_ONDUTY,
    payload: values,
  };
};

export const createOnDuty = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyCreate(values));
      await dispatch(createOnDutyData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const updateOnDutyData = (values) => {
  return {
    type: UPDATE_ONDUTY,
    payload: values,
  };
};

export const updateOnDuty = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(onDutyUpdate(values));
      await dispatch(updateOnDutyData(JSONData));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const deleteOnDutyData = (values) => {
  return {
    type: DELETE_ONDUTY,
    payload: values,
  };
};

export const deleteOnDuty = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(onDutyDelete(values));
      await dispatch(deleteOnDutyData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

export const setOnDutyId = (values) => {
  return {
    type: SET_ONDUTY_ID,
    payload: values,
  };
};